import React, { useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import FinalStep from "../components/FinalStep";
import {
  EVENT_NAMES,
  PARAM_KEYS,
  setPersistentContext,
  trackEvent,
} from "../analytics";

const CAMPAIGN_STORAGE_KEY = "homehelper_campaign_id";

function getStoredCampaignId() {
  try {
    const raw = localStorage.getItem(CAMPAIGN_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.value || !parsed?.expiresAt || Date.now() > parsed.expiresAt) {
      localStorage.removeItem(CAMPAIGN_STORAGE_KEY);
      return null;
    }
    return parsed.value;
  } catch {
    localStorage.removeItem(CAMPAIGN_STORAGE_KEY);
    return null;
  }
}

export default function SurveyCompletePage() {
  const { slug } = useParams();
  const location = useLocation();

  // Passed forward from SurveyPage
  const {
    customerId,
    surveyId,
    projectGuid,
    zip,
    uploadedImages = [],
    regionSlug = null,
    regionName = null,
    proximityAnswer = null,
    livesWithinRegionDriveTime = null,
    regionProximityQuestion = null,
  } = location.state || {};

  if (!customerId || !surveyId) {
    return (
      <div style={{ padding: 32 }}>
        <h2>Session expired</h2>
        <p>Please restart the survey to generate your report.</p>
      </div>
    );
  }

  useEffect(() => {
    const campaignId = getStoredCampaignId();

    if (campaignId) {
      setPersistentContext({
        [PARAM_KEYS.CAMPAIGN_ID]: campaignId,
      });
    }

    trackEvent(EVENT_NAMES.SURVEY_COMPLETE, {
      [PARAM_KEYS.SURVEY_ID]: surveyId,
      [PARAM_KEYS.CATEGORY_KEY]: slug,
      [PARAM_KEYS.PROJECT_GUID]: projectGuid,
      [PARAM_KEYS.HAS_PHOTOS]: uploadedImages.length > 0,
      [PARAM_KEYS.REPORT_TYPE]: "project_summary",
    });
  }, [projectGuid, slug, surveyId, uploadedImages.length]);

  return (
    <FinalStep
      customerId={customerId}
      surveyId={surveyId}
      categoryKey={slug}
      projectGuid={projectGuid}
      zipCode={zip}
      uploadedImages={uploadedImages}
      regionSlug={regionSlug}
      regionName={regionName}
      proximityAnswer={proximityAnswer}
      livesWithinRegionDriveTime={livesWithinRegionDriveTime}
      regionProximityQuestion={regionProximityQuestion}
    />
  );
}
